import { usePreferences } from "../../contexts/PreferencesContext";
import React, { useEffect, useRef, useState } from "react";
import Modal from 'react-bootstrap/Modal';

import '../../css/modal.css';
import { useSelector } from "react-redux";

const ModalRegras = (props) => {const { t } = usePreferences();
  const { processo_name, showModal, setShowModal, regras } = props;
  const user = useSelector((state) => state.AppReducer.user);

  return (
    regras != null && <Modal
      show={showModal == true}
      dialogClassName="modal_width"
      onHide={() => setShowModal(false)}>

            <Modal.Header closeButton closeLabel=''><Modal.Title>{`${t("label_rules")} `}{user.empresa == null || user.empresa.change_text == false ? t("legacy_do_processo") : t("label_of_vacancy_position")} {processo_name}<br /></Modal.Title></Modal.Header>
            <Modal.Body>
                <div className="custom_scrollbar">

                    <div className="jodit-wysiwyg" dangerouslySetInnerHTML={{ __html: regras }} style={{padding:15,borderRadius:10}}>

                    </div>
                </div>

            </Modal.Body>
        </Modal>);


};

export default ModalRegras;
